export enum RenovationCapacityType {
	EXISTING = 'EXISTING',
	EXPANSION_DIFFERENT_FORM = 'EXPANSION_DIFFERENT_FORM',
	EXPANSION_SAME_FORM = 'EXPANSION_SAME_FORM',
	NA = 'NA',
}
